import React from "react";

const Terms = () => {
  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto", lineHeight: "1.7", fontFamily: "Arial, sans-serif" }}>
      <h1>Terms & Conditions</h1>
      <p>Welcome to <strong>RemoraAI</strong>. By using our platform, you agree to the following terms and conditions:</p>

      <h2>1. Use of Service</h2>
      <p>RemoraAI is an AI-powered assistant designed to help you save context, manage projects, and generate AI responses. You may use it for personal or professional purposes, as long as your activities are lawful and respectful.</p>

      <h2>2. User Responsibilities</h2>
      <ul>
        <li>You are responsible for the content you save or input into the platform.</li>
        <li>Do not attempt to misuse, reverse-engineer, or disrupt the AI service.</li>
        <li>Respect copyright and intellectual property when sharing or generating content.</li>
      </ul>

      <h2>3. Data Storage & Memory</h2>
      <p>Most data is stored locally on your device. You can manage, delete, or clear all memories at any time. We are not responsible for any data lost due to user actions or device failures.</p>

      <h2>4. Limitations of AI</h2>
      <p>RemoraAI provides AI-generated responses based on your input. While we strive for accuracy and usefulness, we do not guarantee that all suggestions or outputs will be error-free, complete, or suitable for all use cases.</p>

      <h2>5. Liability</h2>
      <p>By using RemoraAI, you agree that we are not liable for any indirect, incidental, or consequential damages arising from the use of the platform.</p>

      <h2>6. Modifications</h2>
      <p>We may update or improve RemoraAI at any time. Terms and features may change without prior notice, but we will provide updated information on this page.</p>

      <h2>7. Governing Law</h2>
      <p>These terms are governed by the laws of India. Any disputes will be subject to the exclusive jurisdiction of courts in Lucknow, Uttar Pradesh.</p>

      <p style={{ marginTop: "2rem" }}>For any questions about these terms, please contact us at <a href="mailto:codencyindia@gmail.com">codencyindia@gmail.com</a>.</p>
    </div>
  );
};

export default Terms;
